<template>
<div>
    <div class="doc_wrap_header" :class="[{'noWhiteBg':!isWhiteBg},{'headerWhiteFont':isWhiteFont}]">
        <div class="left">
            <img src="../assets/images/nyHome/logo-henan.png" height="54"/>
            <span class="left-step"></span>
            <img src="../assets/images/nyHome/nyLogo-agriknow.png" height="39"/>
          <!-- <span class="version">Beta版</span> -->
        </div>
        <div class="center">
          <!-- <a href="javascript:void(0)" @click="toOtherPage('home')" :class="{ curTab: $route.name == 'home' }">首页</a>
          <a href="javascript:void(0)" @click="toOtherPage('native')" :class="{ curTab: $route.name == 'native' }">原生应用</a>
          <a href="javascript:void(0)" @click="toOtherPage('industry')" :class="{ curTab: $route.name == 'industry' }">行业大模型</a>
          <a href="javascript:void(0)" @click="toOtherPage('solution')" :class="{ curTab: $route.name == 'solution' }">解决方案</a>
          <a href="javascript:void(0)" @click="toOtherPage('model')" :class="{ curTab: $route.name == 'model' }">大模型本地化部署</a>
          <a href="javascript:void(0)" @click="toHuazhiUrl('hzmaas')">开放平台</a> -->
          <!-- <a href="javascript:void(0)" @click="toHuazhiUrl('hzbaike')">核百科问答</a> -->
        </div>
        <div class="right" :style="{opacity:(!hideRight?1:0)}">
            <div v-if="!isLogged">
              <el-button round @click="loginOrRegister('1')">登录</el-button>
              <!--<el-button round @click="loginOrRegister('2')">注册</el-button>-->
            </div>
            <el-dropdown trigger="click" @command="handleCommand" v-if="isLogged">
              <span class="user">
                <img :src="defaultImg" class="logo"/>
                <span class="name" :title="userInfo.realName||userInfo.userName">{{ userInfo.realName||userInfo.userName}}</span>
                <i class="el-icon-caret-bottom"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="header-dropdown">
                <el-dropdown-item command="account">
                  <span>
                    <img src="../assets/images/login/account.png" alt="" class="vam" />
                    我的账户
                  </span>
                </el-dropdown-item>
                <!-- <el-dropdown-item command="agreement">
                  <span>
                    <img src="../assets/images/login/agree.png" alt="" class="vam" />
                    隐私政策
                  </span>
                </el-dropdown-item> -->
                <el-dropdown-item command="exit">
                  <span>
                    <img src="../assets/images/login/exit.png" alt="" class="vam" />
                    退出登录
                  </span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
    <LoginDialog ref="log" v-if="showLogin" />
</div>
</template>
<script>
import { mapState, mapMutations } from "vuex"
import LoginDialog from "./LoginDialog.vue"
import {logOutApi} from '@/api/login.js'
import toHuazhiUrl from "@/mixins/toHuazhiUrlMixins.js"
export default {
  name: "IHeader",
  components: { LoginDialog },
  mixins: [toHuazhiUrl],
  data(){
    return {
      showLogin: false,
      returnUrl: '',
      defaultImg: require('../assets/images/login/defaultImg.png')
    };
  },
  computed: {
    ...mapState(["isLogged", "userInfo", "hideRight"]),
    isWhiteBg(){
      return this.$route.name == 'home'
    },
    isWhiteFont(){
      return this.$route.name == 'solution'
    }
  },
  mounted(){
    this.$bus.$on("needLogin", (url) =>{
      this.loginOrRegister("1", url);
    });
    this.$bus.$on("needExit", () => {
      this.exitLog();
    });
  },
  methods: {
    ...mapMutations(['setState', 'setSocketConnectOnOutline']),
    //跳转其他路由
    toOtherPage(name){
      if (this.$route.name == name) return;
     // if(name == 'solution' || name == "industry") return this.$message.warning({message:'即将上线，敬请期待！',duration:1500});
      this.$router.push({ name: name});
      // let route = this.$router.resolve({ path: `/${name}`, name, meta: name });
      // window.open(route.href);
    },
    //登录或注册
    loginOrRegister(tab, url){
        var link = 'https://www.agriknow.cn/app/login.html?from=hnai';
        if(tab === '2'){
            link = 'https://www.agriknow.cn/app/register.html?from=hnai';
        }
        window.location.href = link;return;
      this.returnUrl = url ? url: ''
      this.showLogin = true;
      this.$nextTick(() =>{
        this.$refs["log"].activeType = tab;
      });
    },
    //隐私协议等
    readProtocol(index){
      let url1 = `${window.location.origin}/agreement/HuazhiUseAgreement.html`
      let url2 = `${window.location.origin}/agreement/HuazhiPrivacyAgreement.html`
      let url = index == 1?url1:url2
      window.open(url,  "_blank");
    },
    //登录后下拉框
    handleCommand(command){
      switch (command) {
        case "account":
          //window.open('https://my.cnki.net/MyCNKI/myAccount.html#/', '_blank')
          window.open('https://www.agriknow.cn/app/center.html', '_blank')
          break;
        case "exit":
          this.exitLog();
          break;
        case "agreement":
           this.readProtocol(2)
           break;
      }
    },
    //退出登录
    async exitLog(){
      let data =  await logOutApi();
      if(!data.success) return;
      this.$cookie.set("ASPID",'',{domain:'.agriknow.cn',expires:-1});
      this.$cookie.set("Ecp_LoginStuts",'',{domain:'.agriknow.cn',expires:-1});
      this.$cookie.set("LID",'',{domain:'.agriknow.cn',expires:-1});
      this.$cookie.set("AID",'',{domain:'.agriknow.cn',expires:-1});
      this.$cookie.set("LID",'',{domain:'ai.agriknow.cn',expires:-1});
      this.$cookie.set("AID",'',{domain:'ai.agriknow.cn',expires:-1});
      this.$cookie.set("c_m_LinID",'',{domain:'.agriknow.cn',expires:-1});
      this.$cookie.set("c_m_expire",'',{domain:'.agriknow.cn',expires:-1});
      await this.setSocketConnectOnOutline(false);
      this.setState({key:"userInfo",value:null});
      this.setState({key:"isLogged",value:false});
        window.location.href = window.location.origin;
    },
  },
};
</script>
<style scoped lang="scss">
$base-color: #0D613F;
.doc_wrap_header{
  background: #fff url(../assets/images/nyHome/header-bg.png) no-repeat center center/cover;
    background-size: auto 100%;
  padding: 0 20px;
  min-width: 1350px;
  height: 75px;
  text-align: center;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  .right {
    width: 200px;
    position: relative;
    z-index: 2;
    .user{
      display: inline-flex;
      align-items: center;
      cursor: pointer;
    }
    .el-button {
      width: 84px;
      height: 34px;
      line-height: 32px;
      border: 1px solid $base-color;
      font-size: 16px;
      color: $base-color;
      padding: 0;
      &:hover {
        background: $base-color;
        color: #fff !important;
      }
      &:focus{
        background-color: #fff;
      }
    }
    .logo {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 5px;
    }
    .name{
      display: inline-block;
      max-width: 4em;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 5px;
    }
  }
  .left {
    display: inline-flex;
    align-items: center;
    position: relative;
    z-index: 2;
      .left-step{font-size: 0;margin-left: 30px;}
    .title{
      font-size: 24px;
      color:#262626
    }
    .logo{
      margin-right: 5px;
      margin-top: 3px;
    }
    .version {
      display: inline-block;
      width: 60px;
      height: 20px;
      line-height: 20px;
      border-radius: 10px;
      margin-top: -20px;
      margin-left: 3px;
      vertical-align: middle;
      background: linear-gradient(0deg, #5870e8, #8be2f7);
      color: #fff;
    }
  }
  .center {
    position: relative;
    z-index: 2;
    font-size: 16px;
    a {
      margin:0 25px;
      &:last-child {
        margin-right: 0;
      }
      &:hover,
      &.curTab {
        color: #4480ee;
      }
    }
  }
}
@media only screen and (max-width: 767px){
    .doc_wrap_header{padding: 0 12px;height: 60px;}
    .doc_wrap_header .left .left-step {margin: 0 6px;height: 20px;}
    .doc_wrap_header .right .el-button{margin-left: 6px;width: auto;height: auto;line-height: 24px;padding: 0 10px;font-size: 12px;
        &:first-child{margin: 0;}
    }
    .doc_wrap_header .right{width: auto;}
}
</style>
